import { useParams } from 'react-router-dom';
import AnnotationsList from '../components/Annotations/AnnotationsList';

export default function ProjectDetail() {
  const { projectId } = useParams();

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">Détail du projet</h1>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold mb-4">Annotations du projet</h2>
        <AnnotationsList targetType="project" targetId={projectId} projectId={projectId} />
      </div>
    </div>
  );
}